import { render, staticRenderFns } from "./CountComponent.vue?vue&type=template&id=0dae8624"
import script from "./CountComponent.vue?vue&type=script&lang=js"
export * from "./CountComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports